export default {
  title: 'MODO',
  login: {
    title: '로그인하여 시작하세요',
    button: '로그인',
    processing: '로그인 중...',
  },
  signup: {
    title: '회원가입하여 시작하세요',
    button: '회원가입',
    processing: '회원가입 중...',
  },
  form: {
    username: '아이디',
    usernamePlaceholder: '아이디를 입력하세요',
    password: '비밀번호',
    passwordPlaceholder: '비밀번호를 입력하세요',
    confirmPassword: '비밀번호 확인',
    confirmPasswordPlaceholder: '비밀번호를 다시 입력하세요',
    email: '이메일',
    emailPlaceholder: '이메일을 입력하세요',
    nickname: '닉네임',
    nicknamePlaceholder: '닉네임을 입력하세요',
  },
  guest: {
    button: '게스트로 계속하기',
  },
  toggle: {
    toSignup: '계정이 없으신가요? 회원가입',
    toLogin: '이미 계정이 있으신가요? 로그인',
  },
}
